import VueBaseController from '../vue_base'

export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/public/orders/show.vue') }
}

export class BacklinksReportsController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/public/orders/backlinks_reports.vue') }

  static values = {
    orderId: String
  }

  connect() {
    super.connect({
      orderId: this.orderIdValue,
    })
  }
}
